// extracted by mini-css-extract-plugin
export default {"permission-item":"_1d4p0mc","permissionItem":"_1d4p0mc"};